import { randomUUID } from 'node:crypto';
import { executeCodeNavRequest } from '../../../../code-nav/handlers/execute-code-nav-request.js';
import type { ShortcutHandlerContext } from '../../../lib/types.js';
import { sendShortcutCodeNavJson, sendShortcutJson } from '../../../lib/response.js';
import { parseCodeNavParams, parseCodeNavPath } from './parse-query.js';

export async function handleShortcutCodeNav(
  ctx: ShortcutHandlerContext,
  sessionId?: string,
): Promise<void> {
  const reqPath = parseCodeNavPath(ctx.url);
  if (reqPath == null) {
    sendShortcutJson(ctx.res, 400, { error: 'path required' });
    return;
  }

  const params = parseCodeNavParams(ctx.url);
  const body = await executeCodeNavRequest(
    {
      id: randomUUID(),
      type: 'code_nav',
      op: params.op,
      path: reqPath,
      line: params.line,
      column: params.column,
      sessionId,
    },
    ctx.sessionWorktreeManager,
  );

  if (body.error != null && body.error.trim().length > 0) {
    sendShortcutJson(ctx.res, 400, { error: body.error });
    return;
  }

  const responseBody: Record<string, unknown> = {
    indexReady: body.indexReady ?? false,
    definition: body.definition ?? null,
    definitions: body.definitions ?? [],
    references: body.references ?? [],
    symbols: body.symbols ?? [],
  };
  if (body.confidentTarget !== undefined) {
    responseBody.confidentTarget = body.confidentTarget;
  }

  sendShortcutCodeNavJson(ctx.res, 200, responseBody, ctx.e2ee);
}
